export default __webpack_public_path__ + "static/media/f.e45e8052e2d065857172b99515c4d85c.mp3";